import { Component } from '@angular/core';
import { AppBackdropService } from './app-backdrop.service';

@Component({
  selector: 'od-app-backdrop',
  templateUrl: './app-backdrop.component.html',
  styleUrls: [
    './themes/app-backdrop.component.scss',
    './themes/app-backdrop.component.adnoc.scss',
  ],
  standalone: false,
})
export class AppBackdropComponent {
  constructor(public appBackdropService: AppBackdropService) {}

  public onClick(): void {
    this.appBackdropService.onClick();
  }
}
